<template>
  <div class="cargo-editor" style="display: flex;flex-direction: column;border: 1px solid #ccc;">
    <!-- 工具栏 -->
    <Toolbar :editor="editor" :default-config="toolbarConfig" style="border-bottom: 1px solid #ccc;" />
    <!-- 编辑器 -->
    <Editor
      :value="value"
      :default-config="editorConfig"
      mode="simple"
      style="flex-grow: 1;overflow-y: hidden;"
      @onCreated="onCreated"
      @input="onInput"
    />
  </div>
</template>

<script>
import { Toolbar, Editor } from '@wangeditor/editor-for-vue'

export default {
  name: 'CargoEditor',
  components: { Toolbar, Editor },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    excludeKeys: { type: Array, default: () => [] }
  },
  data() {
    return {
      editor: null,
      editorConfig: {
        placeholder: this.placeholder,
        hoverbarKeys: {
          pre: { menuKeys: [] }
        }
      }
    }
  },
  computed: {
    toolbarConfig() {
      return {
        toolbarKeys: [
          'bold', // 加粗
          'italic', // 斜体
          'underline', // 下划线
          'through', // 删除线
          '|',
          'blockquote', // 引用
          'codeBlock', // 代码块
          '|',
          'header1', // 1级标题
          'header2', // 2级标题
          '|',
          'fontSize', // 字体大小
          '|',
          'headerSelect', // 标题
          '|',
          'clearStyle', // 清除文本格式
          '|',
          'insertLink', // 插入链接
          'insertImage', // 插入图片
          'insertTable' // 插入表格
        ],
        excludeKeys: this.excludeKeys
      }
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy() // 组件销毁时，及时销毁editor
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用Object.seal()，否则会报错
      this.$emit('onCreated', editor)
    },
    onInput(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
.cargo-editor {
  span[data-value='header1'], h1 span {
    font-size: 24px;
  }
  span[data-value='header2'], h2 span {
    font-size: 18px;
  }
  span[data-value='header3'], h3 span {
    font-size: 14.04px;
  }
  span[data-value='header5'], h5 span {
    font-size: 9.96px;
  }
}
</style>
